// Traduções em Português Europeu — registo acessível e claro
// RTL: não

export const PT = {
  lang: 'pt',
  dir: 'ltr',

  nav: {
    home: 'Início',
    back: 'Voltar',
    modules: 'Módulos',
    about: 'Sobre nós',
    start: 'Começar',
    close: 'Fechar',
    jeexplique: 'Como funciona?',
    guide: 'Guia',
    textLarger: 'Texto maior?',
  },

  hero: {
    tag: '✦ Gratuito · Sem inscrição · Sem julgamento',
    title: 'O seu consultor administrativo digital,\numa linguagem clara e simples.',
    subtitle: 'DémarchesClaires guia-o passo a passo nos procedimentos administrativos online — cartas da CAF, preencher PDF, emails, processos. Em 5 minutos, compreende e age.',
    cta: 'Começar gratuitamente →',
    explain: 'Como funciona o site? 😊',
    badge: '✦ 3 perguntas rápidas → o seu percurso personalizado imediatamente',
  },

  stats: {
    modules: 'temas do quotidiano',
    lessons: 'lições disponíveis',
    lessonsCompleted: 'lições completadas',
    free: 'gratuito para sempre',
    sourceBtn: '📰 Ler a fonte',
    statsTitle: '📊 Em França hoje',
    stat1num: '15%', stat1label: 'da população em situação de exclusão digital (INSEE 2023)',
    stat2num: '28%', stat2label: 'têm competências digitais fracas (Crédoc 2022)',
    stat3num: '29%', stat3label: 'não realizaram nenhuma démarche desmaterializada em 12 meses (Crédoc 2022)',
  },

  testimonials: {
    title: '💬 Os seus testemunhos',
    t1: { name: 'Claudette, 71 anos — Creuse', text: 'Perdia as consultas do Ameli porque não sabia ligar-me. Agora faço tudo sozinha.' },
    t2: { name: 'Rachid, 44 anos — Seine-Saint-Denis', text: 'Nunca tinha feito a declaração de impostos online. Com o módulo dedicado, fiz tudo sozinho em 20 minutos.' },
  },

  persona: {
    sectionTitle: 'Parecem-se connosco',
    name: 'Maria, 62 anos',
    story: 'Recebeu uma carta da CAF a pedir documentos em 15 dias. A linguagem administrativa, preencher um PDF, digitalizar e juntar ficheiros... tudo isso a ultrapassa. O stress aumenta.',
    result: '✓ Com o DémarchesClaires, Maria completou o processo sozinha em poucos dias. A confiança voltou.',
  },

  ia: {
    title: 'A IA no coração do DémarchesClaires',
    desc: 'Não é um curso magistral. Uma IA que observa, se adapta e guia pessoalmente.',
    features: [
      { icon: '🎯', label: 'Diagnóstico', desc: 'Avalia o seu nível' },
      { icon: '🔄', label: 'Percurso pessoal', desc: 'Adaptado a si' },
      { icon: '💡', label: 'Feedback', desc: 'Explica os erros' },
    ],
  },

  modules: {
    sectionTitle: 'Módulos disponíveis',
    title: 'Escolha o seu módulo',
    subtitle: 'Cada módulo resolve um problema concreto do quotidiano',
    lessons: 'lições',
    completed: 'completado',
    progress: 'O seu progresso',
    start: 'Começar a lição →',
    continue: 'Continuar →',
    done: '✓ Completado',
    lessonsCount: 'lições completadas',
  },

  moduleNames: {
    courrier:       'Compreender as cartas oficiais',
    pdf:            'Preencher um PDF',
    email:          'Emails administrativos',
    dossier:        'Organizar o processo',
    securite:       'Segurança digital',
    impots:         'Declaração de impostos',
    cartevitale:    'Cartão Vitale e saúde',
    rsacaf:         'Tudo sobre a CAF',
    logement:       'Habitação e APL',
    dossiermedical: 'Processo médico',
    formation:      'Formação profissional',
    permis:         'Carta de condução',
    banque:         'Conta bancária',
    smartphone:     'Smartphone para principiantes',
  },

  lesson: {
    context: 'Contexto',
    question: 'Pergunta',
    validate: 'Confirmar ✓',
    correct: '✅ Resposta correcta!',
    wrong: '❌ Resposta errada',
    next: 'Próxima lição →',
    finish: '🎉 Terminar o módulo',
    explanation: 'Explicação',
    lessonOf: 'Lição {n} de {total}',
  },

  moduleEnd: {
    congrats: '🎉',
    title: 'Completou a lição!',
    desc: 'Parabéns! Completou a lição',
    desc2: 'Cada passo aprendido é um documento a menos que o assusta. Continue!',
    nextModule: 'Próxima lição',
    allModules: 'Todos os módulos',
    retry: 'Rever esta lição',
    allDone: '🏆 Completou todas as lições!',
    stats: { lessons: 'lições', completed: 'completado', badge: 'medalha' },
  },

  onboarding: {
    title: 'Bem-vindo 👋',
    subtitle: 'Responda a 3 perguntas para o orientarmos melhor',
    skip: 'Saltar e começar directamente →',
    cta: 'Vamos lá! →',
    allModules: 'Ver todos os módulos',
    questions: [
      {
        id: 'defi',
        question: 'Qual é o seu maior desafio neste momento?',
        emoji: '🎯',
        options: [
          { id: 'courrier', text: '📬 Recebo cartas da CAF, CPAM, impostos que não compreendo', module: 'courrier' },
          { id: 'pdf', text: '📄 Tenho de preencher formulários PDF e não sei como', module: 'pdf' },
          { id: 'email', text: '✉️ Tenho dificuldade em enviar emails com anexos', module: 'email' },
          { id: 'dossier', text: '📁 Preciso de organizar um processo e reunir documentos', module: 'dossier' },
          { id: 'securite', text: '🔒 Tenho medo de burlas e quero proteger os meus dados', module: 'securite' },
          { id: 'impots', text: '🧾 Tenho de fazer a declaração de impostos e não sei como', module: 'impots' },
          { id: 'cartevitale', text: '💊 Tenho dúvidas sobre o meu cartão Vitale ou reembolsos', module: 'cartevitale' },
          { id: 'rsacaf', text: '🏛️ Quero conhecer os meus direitos na CAF — RSA, subsídios, ajudas', module: 'rsacaf' },
          { id: 'logement', text: '🏠 Procuro habitação social ou quero compreender os meus direitos', module: 'logement' },
          { id: 'dossiermedical', text: '🏥 Quero aceder ao meu processo médico ou organizar documentos de saúde', module: 'dossiermedical' },
        ]
      },
      {
        id: 'niveau',
        question: 'Considera-se mais...',
        emoji: '📊',
        options: [
          { id: 'debutant', text: '🌱 Principiante — o digital assusta-me' },
          { id: 'moyen', text: '🌿 Com alguma facilidade — consigo mas tenho dificuldades' },
          { id: 'avance', text: '🌳 À vontade — quero apenas compreender os processos administrativos' },
        ]
      },
      {
        id: 'appareil',
        question: 'Utiliza principalmente...',
        emoji: '📱',
        options: [
          { id: 'telephone', text: '📱 O meu telemóvel' },
          { id: 'ordinateur', text: '💻 O meu computador' },
          { id: 'les_deux', text: '📱💻 Os dois' },
        ]
      },
    ],
    messages: {
      courrier: { titre: 'Comecemos pelas cartas oficiais', desc: 'É muitas vezes aqui que tudo bloqueia. Vamos desmistificar juntos.', module: 'courrier' },
      pdf: { titre: 'Vamos atacar os PDF', desc: 'Preencher um formulário PDF sem stress — é possível. Mostramos-lhe.', module: 'pdf' },
      email: { titre: 'Vamos dominar os emails', desc: 'Enviar anexos, reconhecer burlas — passo a passo.', module: 'email' },
      dossier: { titre: 'Vamos organizar o seu processo', desc: 'Reunir os documentos certos no momento certo — guiamo-lo.', module: 'dossier' },
      securite: { titre: 'Protejamos os seus dados', desc: 'Reconhecer burlas, proteger as suas contas — ficará tranquilo.', module: 'securite' },
      impots: { titre: 'Vamos fazer a declaração de impostos juntos', desc: 'Passo a passo em impots.gouv.fr — em poucos minutos está feito.', module: 'impots' },
      cartevitale: { titre: 'Vamos dominar o seu cartão Vitale', desc: 'Ameli, reembolsos, actualização — explicamos tudo.', module: 'cartevitale' },
      rsacaf: { titre: 'Descubramos tudo o que a CAF pode fazer por si', desc: 'RSA, subsídios, PAJE — simule os seus direitos em poucos minutos.', module: 'rsacaf' },
      logement: { titre: 'Vamos encontrar a sua habitação', desc: 'Pedido HLM, APL, direitos dos inquilinos — guiamo-lo passo a passo.', module: 'logement' },
      dossiermedical: { titre: 'Vamos gerir o seu processo médico', desc: 'Mon Espace Santé, receitas, direitos dos doentes — tudo explicado.', module: 'dossiermedical' },
    },
  },

  about: {
    tag: 'Sobre nós',
    title: 'DémarchesClaires — Administração para todos',
    mission: 'Projecto gratuito e de código aberto, que ajuda pessoas com exclusão digital a tratar dos seus processos administrativos online.',
    persona: 'Maria, 62 anos, recebeu uma carta da CAF a pedir documentos em 15 dias. DémarchesClaires permitiu-lhe concluir tudo sozinha.',
    team: 'A equipa',
    openSource: 'Projecto de código aberto',
  },

  footer: {
    home: 'Início',
    modules: 'Módulos',
    progress: 'O meu progresso',
    about: 'Sobre nós',
    contact: 'Contacte-nos',
    mention: 'Um projecto cívico · Código aberto · Dados protegidos',
  },

  burger: {
    navigation: 'Navegação',
    modules: 'Módulos',
    home: 'Início',
    about: 'Sobre nós',
    language: 'Língua',
  },

  badges: {
    courrier:       'Especialista em cartas',
    pdf:            'Especialista PDF',
    email:          'Especialista email',
    dossier:        'Especialista processos',
    securite:       'Guardião digital',
    impots:         'Especialista impostos',
    cartevitale:    'Especialista saúde',
    rsacaf:         'Especialista CAF',
    logement:       'Especialista habitação',
    dossiermedical: 'Especialista processo médico',
    formation:      'Especialista formação',
    permis:         'Especialista carta condução',
    banque:         'Especialista banco',
    smartphone:     'Especialista smartphone',
  },


  situations: {
    title: '🚨 Tem um problema agora?',
    subtitle: 'Clique na sua situação — guiamo-lo diretamente.',
    courrier: "Recebi uma carta oficial que não entendo",
    courrierSub: 'CAF, finanças, prefeitura…',
    pdf: "Pedem-me para preencher ou assinar um formulário",
    pdfSub: 'PDF, formulário oficial, documento online…',
    caf: "Quero conhecer os meus direitos e ajudas",
    cafSub: 'RSA, APL, abonos de família, CAF…',
    sante: "Tenho uma questão sobre a minha saúde ou reembolsos",
    santeSub: 'Carte Vitale, Ameli, seguro de saúde…',
    logement: "Tenho um problema com a minha habitação",
    logementSub: 'Renda, despejo, APL, habitação social…',
  },
  marie: {
    title: 'Maria, 62 anos — carta da CAF recebida esta manhã',
    desc: 'A linguagem administrativa, preencher um PDF, digitalizar um documento — tudo isso a ultrapassa. Com o DémarchesClaires, ela resolve sozinha,',
    highlight: 'em menos de 15 minutos',
    badge1: 'Gratuito',
    badge2: 'Sem inscrição',
    badge3: 'Sem julgamento',
  },

  quefaire: {
    title: 'Uma carta o preocupa?',
    sub: 'Dizemos-lhe o que significa e o que deve fazer — em palavras simples.',
  },

  contact: {
    title: 'Escrever-nos',
    sub: 'Uma pergunta? Uma sugestão? Escreva-nos.',
    name: 'O seu nome *',
    email: 'O seu email (para lhe responder)',
    message: 'A sua mensagem *',
    send: 'Enviar a mensagem',
    sending: 'A enviar...',
    ok: '✅ Mensagem enviada! Obrigado.',
    err: '❌ Erro. Tente novamente.',
  },

  errors: {
    moduleNotFound: 'Módulo não encontrado',
  },
  stickyFooter: {
    title: "Não sabe por onde começar?",
    subtitle: "3 perguntas → o seu percurso personalizado",
    cta: "Teste de diagnóstico gratuito →",
  },
  heroV2: {
    hero_title: "Pare de sofrer com\nos procedimentos administrativos",
    hero_subtitle: "Cole a sua carta. A nossa IA analisa e guia-o em 5 segundos.",
    hero_badge: "IA \u00b7 7 l\u00ednguas \u00b7 Gratuito",
    hero_cta_main: "\u26a1 Analisar agora",
    hero_cta_demo: "Ver a demonstra\u00e7\u00e3o (30s)",
    hero_reassurance1: "\u2713 Sem registo",
    hero_reassurance2: "\u2713 Dados eliminados ap\u00f3s an\u00e1lise",
    demo_title: "Veja o resultado antes de come\u00e7ar",
    demo_subtitle: "Isto \u00e9 o que a IA produz em 5 segundos com uma carta real",
    demo_analyse: "Mistral est\u00e1 a analisar a sua carta",
    demo_cta: "Analisar a minha carta \u2192",
    demo_courrier: "Caro/a Senhor/a,\nInformamos que o seu processo CAF n\u00b0 2847156 foi suspenso. Deve fornecer comprovativos de rendimento antes de 18 de fevereiro de 2026.",
    demo_reponse: "\ud83d\udccb A CAF suspendeu as suas presta\u00e7\u00f5es\n\n\u2705 O que fazer:\n1. Reunir os seus recibos de vencimento (\u00faltimos 3 meses)\n2. Envi\u00e1-los via caf.fr ou pessoalmente\n\u23f0 Prazo: antes de 18 de fevereiro \u2014 urgente!",
  },
};
